import { render } from "./Calculator.vue?vue&type=template&id=087e5ae4&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"

import "./Calculator.vue?vue&type=style&index=0&id=087e5ae4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087e5ae4"]])

export default __exports__